import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import { Box, useMediaQuery, IconButton, Typography } from "@material-ui/core";

import Operator from "../Operator/Operator";
import useStyles from "./styles";
import menuIcon2 from "../../assets/img/menu-2.svg";
import closeIcon from "../../assets/img/close-navbar.svg";
import {menuSettings} from "../../constants/settings";
import {bordo, white} from "../../constants/colors";

const Menu = ({ apiData }) => {
  const {
    navLink,
    navbar,
    menu,
    icon,
    shadow,
    menuClose,
    menuContainer,
    menuOpen,
    logoLink,
    navbarElement,
    close,
    callToAction,
    telLink,
    mobileOperator,
  } = useStyles();
  const show = useMediaQuery(({ breakpoints: { down } }) => down("sm"));
  const [isMenuOpen, handleIsMenuOpen] = useState(false);
  const handleMenu = () => {
    handleIsMenuOpen((value) => !value);
  };

  React.useEffect(() => {
    const body = document.querySelector("body");
    if(show) {
      body.style.overflow = isMenuOpen ? "hidden" : "auto";
    } else {
      body.style.overflow = null;
    }
  }, [isMenuOpen, show]);

  return (
    <nav className={navbar}>
      <a
        href={menuSettings.link.home}
        className={`${logoLink} ${navbarElement}`}
        target="_blank"
        rel="noreferrer"
      >
        <img src={menuSettings.LogoImg} alt="logo" width={process.env.REACT_APP_PROJECT === "bcf" ? "auto" : "66"} />
      </a>
      <Box>
        {show && isMenuOpen && <div className={shadow} onClick={handleMenu} />}
        <div
          className={`${show && menuContainer} ${
            isMenuOpen ? menuOpen : menuClose
          }`}
        >
          <div className={`${show && menu}`}>
            <a
              href={menuSettings.link.home}
              className={navLink}
              target="_blank"
              rel="noreferrer"
            >
              Home
            </a>
            {menuSettings.link.bestDeal.length > 0 &&
              <a
                href={menuSettings.link.bestDeal}
                className={navLink}
                target="_blank"
                rel="noreferrer"
              >
                Deals
              </a>
            }
            {menuSettings.link.blog.length > 0 &&
            <a
              href={menuSettings.link.blog}
              className={navLink}
              target="_blank"
              rel="noreferrer"
            >
              Blog
            </a>
            }
            {menuSettings.link.about.length > 0 &&
            <a
              href={menuSettings.link.about}
              className={navLink}
              target="_blank"
              rel="noreferrer"
            >
              About us
            </a>
            }
            {menuSettings.link.contact.length > 0 &&
            <a
              href={menuSettings.link.contact}
              className={navLink}
              target="_blank"
              rel="noreferrer"
            >
              Contacts
            </a>
            }


            {show && apiData?.operatorInfo?.phone && (
              <Box
                display="flex"
                flexDirection="column"
                justifyContent="center"
                alignItems="center"
                className={mobileOperator}
              >
                <Operator info={apiData?.operatorInfo} classes={callToAction} />
                <a
                  href={`tel:${apiData?.operatorInfo?.phone}`}
                  className={telLink}
                >
                  <Box>
                    <Typography variant="body2" color="secondary">
                      Call
                    </Typography>
                  </Box>
                </a>
              </Box>
            )}
            {show && (
              <IconButton className={close} onClick={handleMenu} size="small">
                <img src={closeIcon} alt="menuicon" />
              </IconButton>
            )}
          </div>
        </div>
      </Box>
      <Box display="flex" className={navbarElement} justifyContent="flex-end">
        <Operator info={apiData?.operatorInfo} />
        <Box ml={1} display="flex">
          {show && (
            <IconButton className={icon} onClick={handleMenu} size="small">
              <img src={menuIcon2} alt="menuicon" />
            </IconButton>
          )}
        </Box>
      </Box>
    </nav>
  );
};

export default Menu;
